import React, { useState } from "react";
import { useDebouncedCallback } from "use-debounce";
import Dropdown from "../../../components/forms/Dropdown";
import { QuestionWithRelations } from "../../../../../api/src/types";
import { QuestionOption } from "../../../../../api/src/types";
import { useGetCurrentUserQuery } from "../../../api/users";
import {
  useCreateAnswerMutation,
  useUpdateAnswerMutation,
} from "../../../api/answers";
import { ErrorWrapper, InputWrapper } from "./SharedFormStyles";

interface DropdownInputProps {
  question: QuestionWithRelations;
}

const DropdownInput: React.FC<DropdownInputProps> = ({ question }) => {
  const [selectedOption, setSelectedOption] = useState<string | null>(
    question.answers[0]?.answerQuestionOptions.map(
      (a) => a.questionOptionId,
    )[0] ?? null,
  );
  const [hasAnswer, setHasAnswer] = useState(question.answers.length > 0);

  const { data: user } = useGetCurrentUserQuery();
  const [
    createAnswer,
    {
      /*isLoading: isCreating,*/
      isError: isCreateError,
      /*isSuccess: isCreateSuccess,*/
      reset: resetCreateAnswer,
    },
  ] = useCreateAnswerMutation();
  const [
    updateAnswer,
    {
      /*isLoading: isUpdating,*/
      isError: isUpdateError,
      /*isSuccess: isUpdateSuccess,*/
      reset: resetUpdateAnswer,
    },
  ] = useUpdateAnswerMutation();

  const save = useDebouncedCallback(async (optionId: string) => {
    if (!user) return;

    const payload = {
      questionId: question.id,
      userId: user.id,
      questionOptionIds: [optionId],
    };

    try {
      if (!hasAnswer) {
        if (optionId) {
          await createAnswer(payload).unwrap();
          setHasAnswer(true);
        }
      } else {
        await updateAnswer(payload).unwrap();
      }
    } catch (err) {
      console.error(err);
    }
  }, 1000);

  const handleDropdownChange = (optionId: string) => {
    resetCreateAnswer();
    resetUpdateAnswer();

    setSelectedOption(optionId);
    void save(optionId);
  };

  //const isLoading = isCreating || isUpdating;
  //const hasError = isCreateError || isUpdateError;
  /*const isSuccess =
    (isCreateSuccess || isUpdateSuccess) &&
    !hasError &&
    !isLoading &&
    selectedOption !== null;
  */

  const options = question.questionOptions
    .map((option: QuestionOption) => ({
      label: option.value,
      value: option.id,
    }))
    .sort((a, b) => {
      if (a.label === "United States of America") return -1;
      if (b.label === "United States of America") return 1;
      return 0;
    });

  return (
    <>
      <InputWrapper>
        <Dropdown
          options={options}
          selectedValue={selectedOption ?? ""}
          onChange={(e: string) => {
            handleDropdownChange(e);
          }}
          dataTestid={question.id}
        />
        {/* Commenting out the loader and success icon for now as per the request of the design team */}
        {/*
        {isLoading && (
          <IconContainer>
            <Loader spinnerOnly={true} size={isMobile ? 16 : 34} />
          </IconContainer>
        )}
        {isSuccess && (
          <IconContainer>
            <GreenTick size={isMobile ? IconSize.S : IconSize.XL} />
          </IconContainer>
        )}
        */}
      </InputWrapper>
      {isCreateError ||
        (isUpdateError && (
          <ErrorWrapper>
            Error saving answer, please refresh the page and try again
          </ErrorWrapper>
        ))}
    </>
  );
};

export default DropdownInput;
